import { FunctionComponent, useContext } from "react";
import CustomDialog from "../../../common/custom-dialog/custom-dialog";
import { Box, Chip, IconButton, Typography } from "@mui/material";
import { MonetizationOn } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";
import { displayMoney } from "../../../../utils/money";
import { MerchantWithIcon } from "../../../common/styles/merchant-with-icon";
import DeliveryChargeOverrides from "../delivery-charge-rules/delivery-charge-overrides";
import { MerchantType } from "../../../../interfaces/delivery-company/merchants";
import { IDeliveryChargeRule } from "../delivery-charge-rules/interfaces";
import { AuthContext } from "../../../../contexts/user-context/user-context";

interface DeliveryChargeOverridesDialogProps {
    onClose: ()=>void
    merchant: MerchantType
    defaultFocus?: IDeliveryChargeRule
    readonly?: boolean
}
 
const DeliveryChargeOverridesDialog: FunctionComponent<DeliveryChargeOverridesDialogProps> = ({onClose, merchant, defaultFocus, readonly=false}) => {
  const {user} = useContext(AuthContext)  
  return <CustomDialog 
          open={true} 
          onClose={onClose}
          fullScreen
          fullWidth
          maxWidth={'xl'}
          PaperProps={{
            sx: {
              padding: 0,
            },
          }}
        >
          <Typography variant='h3' align='center'>
            Extra Charge Rules
          </Typography>

          <MerchantWithIcon centered  merchant={merchant} phone_number={merchant?.phone_number} />
          <Box justifyContent={"center"} display={"flex"} m={0}>
             <Chip label={<>Default Delivery: {displayMoney(merchant?.default_delivery_fee ?? [])}</>} icon={<MonetizationOn />} />
          </Box>
          

          <div
            style={{
              position: 'fixed',
              top: 4,
              right: 4,
            }}
          >
            <IconButton onClick={onClose}>
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

    
            <DeliveryChargeOverrides readonly={readonly} merchant={merchant} defaultFocus={defaultFocus} />
         

      </CustomDialog>
;
}
 
export default DeliveryChargeOverridesDialog;